import React, { useEffect, useMemo, useState } from 'react';
import { PdfViewer } from '~/ui/components';
import { Compare } from '~/ui/components/Compare/Compare';
import { PreviewContainer } from './PreviewModal.styled';

type PreviewModalProps = {
  file?: File | null;
  url?: string;
  isPdf?: boolean;
  name?: string;
  withControls?: boolean;
};

export function PreviewModal({ file, url, name, isPdf, withControls }: PreviewModalProps) {
  const [filePreview, setFilePreview] = useState<string | ArrayBuffer | null>();

  const imagePreview = useMemo(() => {
    if (withControls) {
      return <Compare images={[(filePreview as string) || url]} initialZoom={1} bgColor="transparent" />;
    }

    return <img src={(filePreview as string) || url} alt="document" />;
  }, [filePreview, url, name]);

  useEffect(() => {
    const reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setFilePreview(reader.result);
      };
    }

    return () => {
      reader.abort();
    };
  }, [file]);

  return (
    <PreviewContainer withControls={withControls} isPdf={isPdf}>
      {isPdf ? <PdfViewer controlsPosition="top" url={url} /> : imagePreview}
    </PreviewContainer>
  );
}
